import { Route, Routes } from '@angular/router';
import { environment } from '@env/environment';
import { aviaPageRouteConfig } from './avia-page/avia-page.route-config';
import { excursionsPageRouteConfig } from './excursions-page/excursions-page.route-config';
import { cruisesPageRouteConfig } from './cruises-page/cruises-page.route-config';
import { changePasswordPageRouteConfig } from './change-password-page/change-password-page.route-config';
import { checkoutPageRouteConfig } from './checkout-page/checkout-page.route-config';
import { hotelsPageRouteConfig } from './hotels-page/hotels-page.route-config';
import { logInPageRouteConfig } from './log-in-page/log-in-page.route-config';
import { reservationsPageRouteConfig } from './reservations-page/reservations-page.route-config';
import { toursPageRouteConfig } from './tours-page/tours-page.route-config';

const defaultPageRouteConfig: Route = {
  path: '',
  redirectTo: environment.desktopDefaultPagePath,
  pathMatch: 'full'
};
export const pagesRouteConfig: Routes = [
  {
    path: '',
    loadComponent: () => import('./main-page/main-page.component').then((c) => c.MainPageComponent),
    children: [
      defaultPageRouteConfig,
      //
      toursPageRouteConfig,
      hotelsPageRouteConfig,
      checkoutPageRouteConfig,
      aviaPageRouteConfig,
      excursionsPageRouteConfig,
      cruisesPageRouteConfig,
      changePasswordPageRouteConfig,
      reservationsPageRouteConfig
    ]
  },
  logInPageRouteConfig
];
